import {CSSProperties, MouseEventHandler, useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import "./buttons.scss";
import * as React from "react";
import { PATH } from "../../onboardingpage/modalview/UserModalController";

interface BrandAProps {
    loading?: boolean;
    className? : string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    href? : string;
    children? : any;
    disabled? : boolean
    target? : string;
    style? : CSSProperties;
}
export const BrandA = (props :  BrandAProps) => (
    <a href={props.href} style={props.style} className={(props.className ?? "") + (props.disabled ? " disabled" : "")} onClick={!props.disabled && !props.loading ? props.onClick : undefined} target={props.target ?? ""}>
        {!props.loading && props.children}
        {props.loading && (
            <>
                <span style={{ display : "none"}}>{props.children}</span>
                <ButtonLoader />
            </>
        )}
    </a>
)
interface BrandButtonProps {
    loading?: boolean;
    className? : string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    onMouseDown? : MouseEventHandler<HTMLButtonElement>
    children? : any;
    disabled? : boolean
    type? : 'submit' | 'reset' | 'button';
    style?: CSSProperties;

}
export const BrandButton = (props: BrandButtonProps) => (
    <button type={props.type} style={props.style} disabled={props.disabled} onClick={!props.disabled && !props.loading ? props.onClick : undefined}  className={(props.className ?? "") + (props.disabled ? " disabled" : "")}>
        {!props.loading && props.children}
        {props.loading && (
            <>
                <span style={{ visibility : "hidden"}}>{props.children}</span>
                <ButtonLoader />
            </>
        )}
    </button>
)
interface BrandLinkProps extends BrandAProps{
    to: string;
}
export const BrandLink = (props :  BrandLinkProps) => {
    return (
        <Link to={props.to} style={props.style} target={props.target} className={(props.className ?? "") + (props.disabled ? " disabled" : "")} onClick={!props.disabled && !props.loading ? props.onClick : undefined}>
            {!props.loading && props.children}
            {props.loading && (
                <>
                    <span style={{ visibility : "hidden"}}>{props.children}</span>
                    <ButtonLoader />
                </>
            )}
        </Link>
    )
}

export const ModalBrandLink = (props :  BrandLinkProps) => {
    return (
        <Link to={{search: new URLSearchParams({type: props.to, modal: PATH.MODAL_TYPE}).toString()}} style={props.style} target={props.target} className={(props.className ?? "") + (props.disabled ? " disabled" : "")} onClick={!props.disabled && !props.loading ? props.onClick : undefined}>
            {!props.loading && props.children}
            {props.loading && (
                <>
                    <span style={{ visibility : "hidden"}}>{props.children}</span>
                    <ButtonLoader />
                </>
            )}
        </Link>
    )
}

const ButtonLoader = () => (
    <div className="sk-fading-circle">
        <div className="sk-circle1 sk-circle"></div>
        <div className="sk-circle2 sk-circle"></div>
        <div className="sk-circle3 sk-circle"></div>
        <div className="sk-circle4 sk-circle"></div>
        <div className="sk-circle5 sk-circle"></div>
        <div className="sk-circle6 sk-circle"></div>
        <div className="sk-circle7 sk-circle"></div>
        <div className="sk-circle8 sk-circle"></div>
        <div className="sk-circle9 sk-circle"></div>
        <div className="sk-circle10 sk-circle"></div>
        <div className="sk-circle11 sk-circle"></div>
        <div className="sk-circle12 sk-circle"></div>
    </div>
)